import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";

export const AdminLogin = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Login berhasil");
      nav("/admin");
    } catch (err) {
      toast.error(errMsg(err, "Login gagal"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="relative z-10 flex min-h-[80vh] items-center justify-center px-5" data-testid="admin-login-page">
      <div className="rk-glass w-full max-w-md rounded-3xl p-8">
        <div className="mb-6 inline-grid h-12 w-12 place-items-center rounded-2xl bg-gradient-to-b from-[#ffd700] to-[#e5b80b] text-black rk-gold-glow">
          <Lock size={20} strokeWidth={2.5} />
        </div>
        <h1 className="text-2xl font-bold">Panel JP STORE</h1>
        <p className="mt-1 text-sm text-zinc-500">
          Login untuk MASTER, KAPTEN, dan ANGGOTA.
        </p>
        <form onSubmit={submit} className="mt-7 space-y-4">
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            autoComplete="username"
            className="rk-input"
            data-testid="admin-username"
            required
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="rk-input"
            data-testid="admin-password"
            required
          />
          <button
            type="submit"
            disabled={loading}
            className="rk-btn-primary w-full"
            data-testid="admin-login-submit"
          >
            {loading ? (
              <Loader2 size={16} className="mx-auto animate-spin" />
            ) : (
              "MASUK"
            )}
          </button>
        </form>
      </div>
    </main>
  );
};
